import { plainToClass } from "class-transformer";
import AuthorizationService from "../services/authorizationService";
import RepositoryBase from "./repositoryBase";
import EshopError from "../models/eshopError";
import EshopRequestBuilder from "../data/eshopRequestBuilder";
import EventBus from "../services/eventBus";
import ServerTimeResponse from "entities/serverTimeResponse";

const CURRENT_SERVER_TIME_ERROR = "CURRENT_SERVER_TIME_ERROR";

export default class SystemRepository extends RepositoryBase<EshopRequestBuilder> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(() => apiFactory(), authorizationService, eventBus);
  }

  getCurrentServerTime() {
    return this.callApi((api) =>
      api
        .apiVersion(3)
        .one(`system/current_server_time`)
        .get<ServerTimeResponse>()
        .then((response) => {
          return plainToClass(ServerTimeResponse, response);
        })
        .catch(() => new EshopError(CURRENT_SERVER_TIME_ERROR))
    );
  }
}
